import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import Tooltip from '@mui/material/Tooltip';

import Hubspot from 'main/common/Hubspot';
import APIKeys from 'main/components/APIKeys';
import Hljs from 'main/components/Hljs';

@inject('userStore')
@inject('scanWizardStore')
@observer
class Configure extends React.Component {
    static propTypes = {
        userStore: PropTypes.any,
        scanWizardStore: PropTypes.any
    };

    componentDidMount() {
        const { email } = this.props.userStore.user;
        Hubspot.send(Hubspot.LINUX_SCANNER_NEW_INSTALLATION, { email });
    }

    onLogin = () => {};

    render() {
        const { license, setLicense } = this.props.scanWizardStore;

        return (
            <div>
                <h3>
                    Select API key below to use in scanner{' '}
                    <Tooltip title="Know more about API-keys">
                        <a className="vulners-href" href="/api-keys" target="_blank">
                            <HelpOutlineOutlinedIcon />
                        </a>
                    </Tooltip>{' '}
                </h3>

                <APIKeys onSelect={setLicense} selected={license} onLogin={this.onLogin} scope="scan" />

                {license.id && (
                    <div>
                        <br />
                        <h3>Agent Configuration</h3>
                        Write following config that contains key into <b>/etc/vulners/vulners_agent.conf </b>
                        <Hljs language="bash" className="bash">
                            [DEFAULT]
                            <br />
                            api_key = {license.id}
                        </Hljs>
                    </div>
                )}
            </div>
        );
    }
}

export default Configure;
